import React, { useState } from "react";
import { Button, Col, Form, FormGroup, Input, Row, Spinner } from "reactstrap";

import { Actions } from "../../types";

type Props = Readonly<{
  addNote: Actions["addNote"];
  jobId: string;
  refreshNotes: () => Promise<void>;
}>;

export const AddNote = ({ addNote, jobId, refreshNotes }: Props) => {
  const [submitting, setSubmitting] = useState(false);
  const [comment, setComment] = useState("");
  return (
    <Form
      className="add-note-form"
      onSubmit={e => {
        e.preventDefault();
        const trimmedComment = comment.trim();
        if (trimmedComment.length < 1) {
          return;
        }
        setSubmitting(true);
        addNote(jobId, trimmedComment).then(() => {
          refreshNotes().then(() => {
            setComment("");
            setSubmitting(false);
          });
        });
      }}
    >
      <h4>Add New Note</h4>
      <FormGroup className="mb-0" row>
        <Col className="pr-0">
          <Input
            disabled={submitting}
            onChange={e => {
              setComment(e.target.value);
            }}
            onKeyDown={e => {
              e.stopPropagation();
            }}
            type="textarea"
            value={comment}
          />
        </Col>
        <Col className="d-flex flex-column justify-content-end" xs="auto">
          {submitting && <Spinner className="ml-auto mr-auto mb-2" size="sm" />}
          <Button
            color="primary"
            disabled={submitting || comment.trim().length < 1}
            size="sm"
            type="submit"
          >
            Add
          </Button>
        </Col>
      </FormGroup>
      <Row className="mb-0">
        <Col>
          <small className="form-text text-muted">
            Notes are visible to the job owner and any users added as a collaborator.
          </small>
        </Col>
      </Row>
    </Form>
  );
};
AddNote.displayName = "AddNote";
